import {BaseModel} from "../base";
import {eventGroup} from "../../services/event_group";

class AdminEventGroupModel extends BaseModel {

    constructor(data) {
        super(data);
    }

    static $query(params) {
        return eventGroup.query(params);
    }

    $update(data) {
        if (!data) {
            data = this.getPostData();
        }

        return this.$put('self', {}, data).then((res) => {
            this.constructor(res);
        });
    }

    $delete() {
        this.$flush('self');
        return this.$del('self').then((res) => {

        });
    }

    static $new(eventGroup) {
        return new AdminEventGroupModel(eventGroup);
    }
}

export {
    AdminEventGroupModel
}